const ErrorFallbackUI = ({ message = "Failed to load" }) => {
  return (
    <div className="w-100 h-100 d-flex justify-content-center align-items-center">
      {message}
    </div>
  )
}

export default ErrorFallbackUI;